import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { pink } from "@mui/material/colors";
import { blue } from "@mui/material/colors";
import { purple } from "@mui/material/colors";
import { green } from "@mui/material/colors";
import { red } from "@mui/material/colors";
import { orange } from "@mui/material/colors";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import jQuery from "jquery";
import Skeleton from "@mui/material/Skeleton";

export default function ProductCard({ loading, product }) {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  return (
    <Card sx={{ height: "100%" }}>
      <CardHeader
        avatar={
          loading ? (
            <Skeleton
              animation="wave"
              variant="circular"
              width={40}
              height={40}
            />
          ) : (
            <Avatar
              sx={{
                bgcolor:
                  product.category_id === 22 || product.category_id === 943 //joy
                    ? blue[300]
                    : product.category_id === 937 || product.category_id === 945 //silk
                    ? pink[200]
                    : product.category_id === 940 || product.category_id === 935 //blur
                    ? purple[200]
                    : product.category_id === 939 || product.category_id === 946 //wink
                    ? orange[200]
                    : product.category_id === 941 || product.category_id === 938 //clean
                    ? blue[200]
                    : product.category_id === 936 || product.category_id === 944 //pure
                    ? green[200]
                    : product.category_id === 942 || product.category_id === 934 //glow
                    ? red[200]
                    : blue[200]
              }}
              aria-label={product.category_name}
            >
              {product.category_name.charAt(0)}
            </Avatar>
          )
        }
        title={
          loading ? (
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          ) : (
            product.category_name
          )
        }
      />
      {loading ? (
        <Skeleton sx={{ height: 300 }} animation="wave" variant="rectangular" />
      ) : (
        <CardMedia
          component="img"
          image={loading ? "" : product.image}
          alt={loading ? "" : product.name}
        />
      )}
      <CardContent>
        {loading ? (
          <React.Fragment>
            <Skeleton
              animation="wave"
              height={10}
              style={{ marginBottom: 6 }}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Typography gutterBottom variant="h5" component="div">
              {product.name}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {
                //strip any html tags
                jQuery("<p>" + product.desc + "</p>").text()
              }
            </Typography>
          </React.Fragment>
        )}
      </CardContent>
      <CardActions disableSpacing>
        {loading ? (
          <React.Fragment></React.Fragment>
        ) : (
          <IconButton onClick={() => openInNewTab(product.url)} aria-label="add to cart">
            <ShoppingCartIcon />
          </IconButton>
        )}
      </CardActions>
    </Card>
  );
}
